const Logo = ({ className }) =>
(<>
    <span className={className} style={{ fontFamily: "Vollkorn" }}><span style={{ color: '#1DBFA2' }}>all</span><span style={{ color: '#005555' }}>my.</span><span style={{ color: '#1DBFA2' }}>energy</span></span>
</>);


export default Logo;